<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="postalCodeDialog"
      persistent
      scrollable
      max-width="320"
    >
      <v-card>
        <v-card-title>{{ myTitle }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout
            row
            align-center
            mb-2
          >
            <v-flex
              xs12
              class="text-xs-left"
            >
              <v-text-field
                v-model="postalCode"
                outline
                ref="postalCodeField"
                name="postal_code"
                :label="$t('postal_code')"
                @keyup="checkPostalCode"
                hide-details
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout
            row
            align-center
            mb-2
          >
            <v-flex
              v-if="areaMsg && selectedAreaMode.isDelivery"
              xs12
              class="pl-2 pt-1 pr-2 text-xs-left"
            >
              <v-btn
                icon
                small
                class="ma-0"
              >
                <v-icon
                  small
                  :color="addressIcon.color"
                >{{ addressIcon.icon }}</v-icon>
              </v-btn>
              <span :style="addressResultStyle">{{ addressMsg }}</span>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="secondary"
            block
            @click.native="openDiningModeDialog"
          >Back
          </v-btn>
          <v-btn
            color="primary"
            block
            @click.native="proceedPostalCode"
            :disabled="disableProceed || postalCode.length !== 6"
          >
            <v-progress-circular
              v-if="sortingOutlets && postalCode.length === 6 && disableProceed"
              :indeterminate="sortingOutlets && postalCode.length === 6"
              :size="20"
              color="white"
            ></v-progress-circular>
             Proceed
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'postal-code',
  data: () => ({
    insertPostal: true,
    postalCode: '',
    sortingOutlets: false,
    disableProceed: true,
  }),
  computed: {
    ...mapGetters('area', [
      'selectedArea', 'selectedAreaMode', 'postalCodeDialog', 'nearestOutlet',
      'areaMsg', 'deliverable'
    ]),
    startStyle () {
      return {
        fontWeight: 600,
      }
    },
    addressResultStyle () {
      let styles = {
        fontSize: '14px',
      }
      if (this.deliverable) {
        styles.color = `#00FF00`
      } else {
        styles.color = `#FF0000`
      }
      return styles
    },
    addressIcon () {
      return {
        icon: this.deliverable ? 'fas fa-check' : 'fas fa-times',
        color: this.deliverable ? `#00FF00` : `#FF0000`
      }
    },
    addressMsg () {
      return this.areaMsg
    },
    myTitle () {
      return this.selectedAreaMode ? 'Order for ' + this.selectedAreaMode.name : ''
    }
  },
  watch: {
    // nearestOutlet (newVal, oldVal) {
    //   if (newVal && this.selectedAreaMode.isDelivery && this.deliverable) {
    //     this.$bus.$emit('showFullLoading', true)
    //     this.$store.dispatch('config/changeGid', newVal.GroupID)
    //     this.$store.dispatch('config/changeRid', newVal.ID)
    //     this.$store.dispatch('config/setModeSelected')
    //     this.$router.push({ name: 'welcome' })
    //   }
    // },
  },
  methods: {
    async proceedPostalCode () {
      // check with postal code
      await this.$store.dispatch('area/setPostalCode', this.postalCode)
      if (this.selectedAreaMode.isDelivery) {
        await this.$store.dispatch('area/setNearestOutlet')
        if (this.deliverable) this.$store.dispatch('area/hidePostalCodeDialog')
      } else {
        this.$store.dispatch('area/hidePostalCodeDialog')
      }
    },
    async checkPostalCode () {
      if (this.postalCode.length === 6) {
        this.sortingOutlets = true
        await this.$store.dispatch('area/fetchRestaurantDistance', this.postalCode)
        setTimeout(() => {
          this.sortingOutlets = false
          this.disableProceed = false
        }, 1000)
      } else {
        await this.$store.dispatch('area/clearRestaurantDistance')
        await this.$store.dispatch('area/resetNearestOutlet')
        this.disableProceed = true
      }
    },
    openDiningModeDialog () {
      this.$store.dispatch('area/hidePostalCodeDialog')
      this.$store.dispatch('area/resetSelectedAreaMode')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PostalCode.vue